// extracted by mini-css-extract-plugin
module.exports =  {"collapsible":"yKcDc6u","disabled":"FuTWKRZ","expanded":"UD9QATs"};